export default "__VITE_ASSET__B4neyX_S__"